import { render, staticRenderFns } from "./tween-input-color.vue?vue&type=template&id=9fdccfce&"
import script from "./tween-input-color.vue?vue&type=script&lang=js&"
export * from "./tween-input-color.vue?vue&type=script&lang=js&"
import style0 from "./tween-input-color.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports